import { createSelector } from "redux-starter-kit";
import { State } from "../../types";

export default createSelector<State, boolean>(
  ["auth", "loading"],
  loading => loading
);
